import { WorkSheet } from 'xlsx/types';

const badChars = ['=', '+', '-', '@'];

/**
 * prevent formulas and such from running immediately when opened in Excel
 */
export function purifyCSV(sheet: WorkSheet) {
    for (const cellKey in sheet) {
        if (cellKey[0] !== '!') {
            const cell = sheet[cellKey];
            sheet[cellKey] = { ...cell, v: purifyCSVCell(cell.v) };
        }
    }

    return sheet;
}

function purifyCSVCell(string: string) {
    if (!string || typeof string !== 'string') {
        return string;
    }

    const firstChar = string.charAt(0);
    if (badChars.includes(firstChar)) {
        const search = ',';
        const searchRegExp = new RegExp(search, 'g');
        const str = +string.substring(2).replace(searchRegExp, '');

        if (str && firstChar === '-' && typeof str === 'number') {
            return string;
        }
        return `'` + string;
    } else {
        return string;
    }
}
